// Hinweis, wenn die Schema-Probe keine eindeutige Antwort bekommen hat
// (useSchemaCapabilities mit status failed). Das ist etwas anderes als „Feld
// fehlt", deshalb eigener Text und ein Button für einen neuen Versuch.
import { ArrowPathIcon } from '@heroicons/react/20/solid'

import { classNames } from '../../helper'

export const SCHEMA_PROBE_FAILED_TITLE =
  'Schema-Prüfung fehlgeschlagen, erneut versuchen.'

export const SCHEMA_PROBE_NOTICE_ID = 'schema-probe-notice'

/**
 * @param {object} props
 * @param {() => void} props.onRetry
 * @param {boolean} [props.isRetrying]
 * @param {React.ReactNode} [props.children] Erklärung für die jeweilige Seite
 */
const SchemaProbeNotice = ({
  onRetry,
  isRetrying = false,
  children,
  className
}) => (
  <div
    id={SCHEMA_PROBE_NOTICE_ID}
    tabIndex={-1}
    className={classNames(
      'rounded-md bg-red-50 p-3 text-sm text-red-800 ring-1 ring-inset ring-red-600/20',
      className
    )}
    data-testid='schema-probe-failed'
  >
    <p className='font-semibold text-red-900'>{SCHEMA_PROBE_FAILED_TITLE}</p>
    <p className='mt-1'>
      {children ||
        'Ob diese Umgebung Payment.plan kennt, ist unklar. Pakete bleiben gesperrt, bis die Prüfung klappt.'}
    </p>
    {onRetry && (
      <button
        type='button'
        onClick={() => onRetry()}
        disabled={isRetrying}
        className='mt-2 inline-flex items-center gap-x-1 font-semibold text-red-900 underline disabled:opacity-50'
      >
        <ArrowPathIcon
          className={classNames('h-4 w-4', isRetrying && 'animate-spin')}
          aria-hidden='true'
        />
        Erneut prüfen
      </button>
    )}
  </div>
)

export default SchemaProbeNotice
